import React, { useState, useEffect } from "react";
import { Input, message } from "antd";
import { trackPromise } from "react-promise-tracker";
import Destinatarios from "./Destinatarios";
import "./styles.scss";
import moment from "moment";
import {
  getBannerId,
  getListagemBanner,
  postBanner,
  putBannerId,
  uploadBanner,
} from "../../../../services/http/bannersServico.js";
import { number } from "../../../../services/mask";
import { useHistory } from "react-router-dom/cjs/react-router-dom.js";
import lang from "../../../../assets/idioma/idiomas.js";

export default function BannerForm({
  listarFavoritos,
  setTipoFormulario,
  idBannerEdicao,
  setIdBannerEdicao,
}) {
  const history = useHistory();

  const [ordenacao, setOrdenacao] = useState("");
  const [usuariosRemovidos, setUsuariosRemovidos] = useState([]);
  const [usuarios, setUsuariosNotificacao] = useState([]);
  const [banner, setBanner] = useState({
    titulo: "",
    urlArquivo: "",
    link: "",
    status: "Ativo",
    ordem: null,
  });

  useEffect(() => {
    idBannerEdicao && fnGetBannerId(idBannerEdicao);
  }, [idBannerEdicao]);

  const fnGetBannerId = (id = banner.id) => {
    trackPromise(
      getBannerId(id)
        .then((res) => {
          setBanner(res.data);

          var lista = res.data?.destinatarios.map((e) => ({
            ...e,
            checked: false,
          }));
          setUsuariosNotificacao(lista);
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  const fnPostBanner = (e) => {
    trackPromise(
      postBanner(banner)
        .then((res) => {
          message.success(lang.Banner_cadastrado_com_sucesso);
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  const fnPutBannerId = (id = banner.id) => {
    var obj = {};
    obj.destinatarios = banner.destinatarios;
    obj.titulo = banner.titulo;
    obj.link = banner.link;
    obj.urlArquivo = banner.urlArquivo;
    obj.ordem = banner.ordem;
    obj.id = id;

    trackPromise(
      putBannerId(id, obj)
        .then((res) => {
          message.success(lang.Banner_alterado_com_sucesso);
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const fnBannerStatus = () => {
    var obj = {};
    obj.destinatarios = banner.destinatarios;
    obj.titulo = banner.titulo;
    obj.link = banner.link;
    obj.urlArquivo = banner.urlArquivo;
    obj.ordem = banner.ordem;
    obj.id = banner.id;
    obj.status = banner.status === "Ativo" ? "Inativo" : "Ativo";

    trackPromise(
      putBannerId(banner.id, obj)
        .then((res) => {
          message.success(lang.Banner_alterado_com_sucesso);
          fnGetBannerId();
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  const fnSelecionarImagem = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const maxWidth = 1920;
        const maxHeight = 324;

        trackPromise(
          uploadBanner(file, "banner")
            .then((res) => {
              if (!res.fail && res.data) {
                setBanner((prev) => ({ ...prev, urlArquivo: res.data }));
              }
            })
            .catch((error) => {
              console.error(error);
            })
        );
        // if (img.width === maxWidth && img.height === maxHeight) {
        //   trackPromise(
        //     uploadBanner(file, "banner")
        //       .then((res) => {
        //         if (!res.fail && res.data) {
        //           setBanner((prev) => ({ ...prev, urlArquivo: res.data }));
        //         }
        //       })
        //       .catch((error) => {
        //         console.error(error);
        //       })
        //   );
        // } else {
        //   message.warning(
        //     `O tamanho permitido é ${maxWidth}x${maxHeight} pixels.`
        //   );
        // }
      };
      img.src = event.target.result; // Definir a fonte da imagem
    };

    reader.readAsDataURL(file); // Iniciar a leitura do arquivo
  };
  useEffect(() => {
    var listaUsuarios = [];

    if (usuarios?.length > 0) {
      usuarios?.map((e, i) => {
        if (e.id) {
          listaUsuarios?.push({ userId: e.id });
        }
      });
      setBanner((prev) => ({ ...prev, destinatarios: listaUsuarios }));
    } else {
      setBanner((prev) => ({ ...prev, destinatarios: [] }));
    }
  }, [usuarios]);
  return (
    <div className="col-md-9">
      <div className="row">
        <div
          className="col-md-12"
          style={{ borderBottom: "1px solid #898989" }}
        >
          <span className="titulo-perm">{lang.Banner}</span>
        </div>
      </div>

      <br />
      {/* TITULO */}
      <div className="row">
        <div className="col-md-12">
          <label style={{ marginBottom: -10 }}>{lang.Titulo}</label>
          <Input
            role={require}
            placeholder="Insira o título"
            value={banner.titulo}
            onChange={(e) => {
              setBanner((prev) => ({
                ...prev,
                titulo: e.target.value,
              }));
            }}
            className="input-usuario"
          />
        </div>
      </div>
      <br />
      <div className="row">
        {/* LINK */}
        <div className="col-md-9">
          <label style={{ marginBottom: -10 }}>{lang.Link}</label>
          <Input
            role={require}
            placeholder="Insira o link"
            className="input-usuario"
            value={banner.link}
            onChange={(e) => {
              setBanner((prev) => ({
                ...prev,
                link: e.target.value,
              }));
            }}
          />
        </div>
        {/* ORDEM */}
        <div className="col-md-3">
          <label style={{ marginBottom: -10 }}>{lang.Ordem}:</label>
          <Input
            role={require}
            placeholder={lang.Insira_a_ordem}
            className="input-usuario"
            value={banner.ordem}
            onChange={(e) => {
              setBanner((prev) => ({
                ...prev,
                ordem: number(e.target.value),
              }));
            }}
          />
        </div>
      </div>
      <br />
      {/* IMPORTAR IMAGEM */}
      <div className="row">
        <div className="col-md-4">
          <input
            type="file"
            accept="image/*"
            id="inputImagem"
            onChange={(e) => fnSelecionarImagem(e)}
            style={{
              display: "none",
            }}
          />
          <button
            onClick={() => {
              document.querySelector("#inputImagem").click();
            }}
            className="btn-bannersPrimary"
          >
            {lang.Importar_arquivo}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4">
          <span className="textoBanner">
            {lang.Somente_imagens_nos_formatos_sao_aceitas}
          </span>
          <br />
          <span className="textoBanner">{lang.Png_Jgp_E_Jpeg} </span>
          <br />
          <span className="textoBanner">
            {lang.As_dimensoes_devem_ser_1920_x_324}
          </span>
          <br />
        </div>
      </div>
      {/* IMAGEM NA TELA */}
      <div className="row">
        <div className="col-md-12 p-0 mt-5 mb-5">
          <a href={banner.link} target="_blank">
            {banner.urlArquivo && (
              <img width={"100%"} src={banner.urlArquivo} />
            )}
          </a>
        </div>
      </div>
      {/* TABELA DE USUARIO */}
      <Destinatarios
        setOrdenacao={setOrdenacao}
        ordenacao={ordenacao}
        setUsuariosRemovidos={setUsuariosRemovidos}
        setUsuariosDestinatarios={setUsuariosNotificacao}
        usuariosDestinatarios={usuarios}
        idBannerEdicao={idBannerEdicao}
      />
      {/* BOTOES */}
      <div className="row d-flex justify-content-center">
        <div className="col-md-4 ">
          <button
            onClick={() => {
              window.location.reload();
            }}
            type="submit"
            className=" btn-bannersSecundary"
          >
            {lang.Cancelar}
          </button>
        </div>
        <div className="col-md-4 ">
          <button
            onClick={() => {
              idBannerEdicao ? fnPutBannerId(idBannerEdicao) : fnPostBanner();
            }}
            type="submit"
            className=" btn-bannersPrimary"
          >
            {lang.Salvar}
          </button>
        </div>
      </div>
      <br />
      {idBannerEdicao && (
        <div className="row d-flex justify-content-center">
          <div className="col-md-8 ">
            <button
              onClick={() => {
                fnBannerStatus();
              }}
              type="submit"
              style={{
                background: banner.status === "Ativo" ? "red" : "green",
              }}
              className=" btn-banners"
            >
              {banner.status === "Ativo"
                ? lang.Inativar_Banner
                : lang.Ativar_Banner}{" "}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
